<template>
    <v-dialog v-model="this.drawer" persistent :max-width="this.maxWith">
        <v-card>
            <v-card-title class="headline">{{this.title}}</v-card-title>
            <v-card-text>
                <v-divider/>
                <v-data-table :headers="headers" :items="this.items" hide-default-header hide-default-footer disable-pagination dense/>
                <v-divider/>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed @click.stop="canceledHandler" color="grey lighten-1">キャンセル</v-btn>
                <v-btn v-show="this.visibleStore" depressed color="success" @click.stop="storedHandler">登録</v-btn>
                <v-btn v-show="this.visibleUpdate" depressed color="warning" @click.stop="updatedHandler">更新</v-btn>
                <v-btn v-show="this.visibleDelete" depressed color="error" @click.stop="deletedHandler">削除</v-btn>
                <v-btn v-show="this.visibleChangeStatus" depressed color="success" @click.stop="changeStatusHandler">ステータス変更</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "CustomDialog",
    props: {
        maxWith: {
            type: Number,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        items: {
            type: Array,
            required: true
        },
        drawer: {
            type: Boolean,
            required: true
        },
        visibleStore: {
            type: Boolean,
            default: false
        },
        visibleUpdate: {
            type: Boolean,
            default: false
        },
        visibleDelete: {
            type: Boolean,
            default: false
        },
        visibleChangeStatus: {
            type: Boolean,
            default: false
        },
    },
    data: () => ({
        headers: [
            { text: "名称", value: "name" },
            { text: "データ", value: "value" }
        ],
    }),
    methods: {
        canceledHandler () {
            this.$emit("canceled");
        },
        storedHandler () {
            this.$emit("stored");
        },
        updatedHandler () {
            this.$emit("updated");
        },
        deletedHandler () {
            this.$emit("deleted");
        },
        changeStatusHandler () {
            this.$emit("changeStatus");
        }
    }
};
</script>
